export const DOMAINS = [
  "chinese",
  "math",
  "english",
  "habits",
  "focus-social"
] as const;

export type Domain = (typeof DOMAINS)[number];

export type Difficulty = 1 | 2 | 3 | 4 | 5 | 6;

export interface LevelDefinition<TPayload = unknown> {
  id: string;
  domain: Domain;
  activityType: string;
  difficulty: Difficulty;
  objectives: string[];
  title: string;
  instruction: string;
  promptAudio?: string;
  assets: string[];
  payload: TPayload;
}

export interface ChildProfile {
  id: string;
  nickname: string;
  avatarId: string;
  createdAt: string;
  parentPinHash?: string;
}

export interface AttemptResult {
  id: string;
  profileId: string;
  levelId: string;
  domain: Domain;
  difficulty: Difficulty;
  correctRate: number;
  hintCount: number;
  retryCount: number;
  durationMs: number;
  completedAt: string;
}

export interface DomainMastery {
  domain: Domain;
  score: number;
  recommendedDifficulty: Difficulty;
  updatedAt: string;
}

export interface RewardState {
  stamps: number;
  unlockedDecorationIds: string[];
}

export interface DailyPlan {
  profileId: string;
  date: string;
  levelIds: string[];
  targetMinutes: number;
}

export interface ParentReport {
  profile: ChildProfile;
  mastery: DomainMastery[];
  recentAttempts: AttemptResult[];
  practicedMinutes: number;
  suggestedDomains: Domain[];
}

export interface ProgressRepository {
  listProfiles(): Promise<ChildProfile[]>;
  getProfile(profileId: string): Promise<ChildProfile | undefined>;
  saveProfile(profile: ChildProfile): Promise<void>;
  deleteProfile(profileId: string): Promise<void>;
  listAttempts(profileId: string): Promise<AttemptResult[]>;
  saveAttempt(result: AttemptResult): Promise<void>;
  getMastery(profileId: string): Promise<DomainMastery[]>;
  saveMastery(profileId: string, mastery: DomainMastery[]): Promise<void>;
  getRewards(profileId: string): Promise<RewardState>;
  saveRewards(profileId: string, rewards: RewardState): Promise<void>;
  exportProfile(profileId: string): Promise<string>;
  importProfile(serialized: string): Promise<ChildProfile>;
  clearAll(): Promise<void>;
}
